/**
 * Application Constants
 * Centralized constants to avoid magic numbers and hardcoded values
 */

export const APPBAR_HEIGHT = "60px"; // Height for the modern look
export const QUICK_ACCESS_APPBAR_HEIGHT = "36px"; // Height for the quick access toolbar
export const QUICK_ACCESS_APPBAR_HEIGHT_PLUS_MARGIN = `calc(${QUICK_ACCESS_APPBAR_HEIGHT} + 36px)`; // Height plus margin

// Theme Constants
export const THEME_CONSTANTS = {
  DRAWER_WIDTH: 280,
  HEADER_HEIGHT: 64,
  MOBILE_HEADER_HEIGHT: 56,
  BORDER_RADIUS: {
    SMALL: 4,
    MEDIUM: 8,
    LARGE: 12,
    XLARGE: 16
  },
  SPACING: {
    SMALL: 8,
    MEDIUM: 16,
    LARGE: 24,
    XLARGE: 32
  },
  SHADOWS: {
    LIGHT: '0 2px 8px rgba(0,0,0,0.1)',
    MEDIUM: '0 4px 16px rgba(0,0,0,0.15)',
    HEAVY: '0 8px 32px rgba(0,0,0,0.2)',
    GLASSMORPHISM: '0 8px 32px rgba(0,0,0,0.12), inset 0 1px 0 rgba(255,255,255,0.20)'
  },
  TYPOGRAPHY: {
    FONT_WEIGHTS: {
      LIGHT: 300,
      REGULAR: 400,
      MEDIUM: 500,
      SEMIBOLD: 600,
      BOLD: 700,
      EXTRABOLD: 800
    }
  }
};

// Animation Constants
export const ANIMATION_CONSTANTS = {
  DURATION: {
    FAST: 200,
    NORMAL: 300,
    SLOW: 500,
    SLOWER: 800
  },
  EASING: {
    EASE_IN: 'cubic-bezier(0.4, 0, 1, 1)',
    EASE_OUT: 'cubic-bezier(0, 0, 0.2, 1)',
    EASE_IN_OUT: 'cubic-bezier(0.4, 0, 0.2, 1)',
    EASE_SHARP: 'cubic-bezier(0.4, 0, 0.6, 1)'
  }
};

// Color Constants  
export const COLOR_CONSTANTS = {
  WHITE: '#FFFFFF',
  BLACK: '#000000',
  TRANSPARENT: 'transparent'
};

// Accessibility Constants
export const ACCESSIBILITY_CONSTANTS = {
  FOCUS_VISIBLE_OUTLINE: '2px solid',
  FOCUS_VISIBLE_OFFSET: '2px',
  MIN_TOUCH_TARGET: 44,
  CONTRAST_RATIOS: {
    NORMAL_TEXT: 4.5,
    LARGE_TEXT: 3.0,
    UI_COMPONENTS: 3.0
  }
};

// Default Values
export const DEFAULT_VALUES = {
  HERO_SECTION: {
    STATS: [
      { value: "50K+", label: "Users", iconName: "TrendingUp" },
      { value: "99.9%", label: "Uptime", iconName: "Security" },
      { value: "24/7", label: "Support", iconName: "Speed" }
    ],
    FEATURES: [
      "Enterprise Security",
      "24/7 Support", 
      "Global CDN",
      "Auto Scaling"
    ]
  }
};